/**
 * Copyright Mántum All Rights Reserved.
 */
import Input from '../input';
import { forwardRef, useRef, useImperativeHandle } from 'react';

import type { Validation, Detail } from '@mantum/kanela';

type PropTypes = {
    autocomplete?: 'off' | 'email' | 'current-password' | 'username';
    disabled?: boolean;
    error?: boolean;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: unknown) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: string;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function Text(props, ref) {
        // prettier-ignore
        const {
        optional = true
    } = props;

        const validationRef = useRef<Detail<string>>(null);

        useImperativeHandle(
            ref,
            () => {
                return {
                    name: validationRef.current?.name,
                    validable: validationRef.current?.validable ?? true,
                    clear() {
                        validationRef.current?.clear();
                    },
                    validate() {
                        const result = validationRef.current?.validate();
                        if (result) {
                            return true;
                        }
                        return false;
                    },
                    value() {
                        return validationRef.current?.value();
                    }
                };
            },
            []
        );

        return (
            <Input
                autocomplete={props.autocomplete}
                disabled={props.disabled}
                error={props.error}
                message={props.validation?.message}
                name={props.name}
                onBlur={props.onBlur}
                onChange={props.onChange}
                optional={optional}
                placeholder={props.placeholder}
                ref={validationRef}
                testid={props.testid}
                type='text'
                value={props.value}
            />
        );
    }
);
